import axios from "axios";

class Desc {
  getAll(data) {
    return axios.get(`/desc`, { params: data });
  }
}

export default new Desc({});
